import { combineReducers } from 'redux';

import { payments } from './payments/payments';
import { recurringReceivables } from './recurringReceivables/recurringReceivables';

const pagination = combineReducers({
  payments,
  recurringReceivables,
});

export { pagination };
